module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8019.334cef93.png";